import { useCallback, useEffect } from "react";
import { useRouter } from "next/router";

import clsx from "clsx";

import ApiError from "api/Error";

import { SingleColumnSelect } from "modules/data-files/elements/Column-Select";

import * as flowConfig from "flows/time-series/config";

import { useGetCreate } from "./api";
import { useInputFile, useTimestamp } from "./store";

import SelectData from "./Select-Data";

const CreateProject = () => {
  const router = useRouter();
  const data = router.query.data as string;
  const { push } = router;

  const [currentFile, setCurrentFile] = useInputFile();
  const [timestampColumn, setTimestampColumn] = useTimestamp(currentFile);

  const [createProject, submitStatus, error] = useGetCreate();

  useEffect(() => {
    if (data && data !== currentFile) {
      setCurrentFile(data);
    }
  }, [data, currentFile]);

  const create = useCallback(async () => {
    const resp = await createProject();
    if (resp?.success) {
      push(`/${flowConfig.FLOW_NAME}/${resp.project.id}`);
    }
  }, [createProject, push]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="pb-4 mb-8">
        <h1 className="h2 text-center">Start Time-Series Analysis</h1>
      </div>
      <SelectData />
      {currentFile && (
        <>
          <div className="flex mt-2 pt-2">
            <div className="w-1/4">
              <label htmlFor={"time-stamp"} className="font-bold">
                2. Select Time-Stamp Column:
              </label>
            </div>
            <div className="w-full">
              <SingleColumnSelect
                name="time-stamp"
                fileId={currentFile}
                currentSelection={timestampColumn}
                onChange={setTimestampColumn}
                allowedTypes={["numeric", "date"]}
                placeholder="Select Time Column"
              />
            </div>
          </div>
        </>
      )}
      {submitStatus === "completed" && error && <ApiError error={error} />}
      {currentFile && timestampColumn && (
        <div className="text-center my-4 py-4">
          <div className="flex flex-wrap -mx-3">
            <div className="w-full px-3">
              <button
                className={clsx(
                  "btn px-0",
                  "text-white",
                  "bg-indigo-600 hover:bg-indigo-700",
                  "w-full",
                  "relative",
                  "flex items-center"
                  // submitStatus === "in-progress" && "cursor-not-allowed"
                )}
                disabled={submitStatus === "in-progress"}
                onClick={create}
              >
                {submitStatus === "in-progress" && (
                  <svg
                    className="animate-spin h-5 w-5 mr-3  text-white"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                )}
                {submitStatus === "in-progress"
                  ? "Creating..."
                  : "Create New Project"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateProject;
